import Card from './ui/Card';

interface AboutProps {
  t: {
    title: string;
    subtitle: string;
    card1Title: string;
    card1Text: string;
    card2Title: string;
    card2Text: string;
  }
}

const About = ({ t }: AboutProps) => {
  return (
    <section id="about" className="pt-2 pb-12 sm:pt-4 sm:pb-24 bg-slate-900/70">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-black text-white">{t.title}</h2>
          <p className="mt-4 text-lg text-slate-400 max-w-3xl mx-auto">{t.subtitle}</p>
        </div>
        <div className="grid md:grid-cols-2 gap-8 items-center">
          <Card>
              <h3 className="text-2xl font-bold text-blue-400 mb-4">{t.card1Title}</h3>
              <p className="text-slate-300">
                {t.card1Text}
              </p>
          </Card>
          <Card>
              <h3 className="text-2xl font-bold text-green-400 mb-4">{t.card2Title}</h3>
              <p className="text-slate-300">
                {t.card2Text}
              </p>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default About;